import injector from 'vue-inject'

export function validateReceiptCarrierId (receiptCarrier, receiptCarrierId) {
  const barcode = injector.get('receiptCarrierType').barcode
  const cdc = injector.get('receiptCarrierType').cdc
  const barcodeRegex = /^[\dA-Z.\-+]{7}$/
  const cdcRegex = /^[A-Z]{2}[\d]{14}$/
  const donate = injector.get('receiptCarrierType').donate
  const donateRegex = /^[\d]{3,7}$/
  const f = id => (receiptCarrier === barcode && barcodeRegex.test(id)) || (receiptCarrier === cdc && cdcRegex.test(id)) || (receiptCarrier === donate && donateRegex.test(id))
  return arguments.length === 2 ? f(receiptCarrierId) : f
}

export function validateTaxId (taxId) {
  return taxId === undefined ? true : taxId.length === 0 || taxId.length === 8
}

export function validatePhoneNumber (phoneNumber) {
  return phoneNumber && phoneNumber.length === 10
}
